// extracted by mini-css-extract-plugin
export default {"video":"VideoPlayer_video__JbYES"};